import { RoomJoinedPayload } from 'features/room/types';
import { PublishingOptions, RTCClient } from 'utils/webrtc';
import { call, fork, put, select } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { establishJanusConnectionSaga } from 'features/room/sagas/establishJanusConnectionSaga';
import { roomError, roomJoined } from 'features/room/roomSlice';
import { configureSDKStoredStateSaga } from 'features/sdk/configureSDKStoredStateSaga';
import * as Sentry from '@sentry/react';
import { setSentryIdentity } from 'utils/sentry/setSentryIdentity';
import { setupE2eeSaga } from 'features/e2ee/sagas/setupE2eeSaga';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { externalStreamStarted } from 'features/streaming/actions';

export function* onRoomJoinConfigSaga(data: RoomJoinedPayload) {
  try {
    yield call(setSentryIdentity, {
      session_id: data.sessionId,
      room_id: data.roomId,
      main_room_id: data.mainRoomId || data.roomId,
      is_breakout: data.breakout,
    });

    if (data.user.externalId) {
      yield fork(Sentry.setTag, 'external_id', data.user.externalId);
      yield fork(Sentry.setAttribute, 'external_id', data.user.externalId);
    }

    const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
    if (e2eeEnabled) {
      yield call(setupE2eeSaga, data);
    }

    yield call(eventBus.sendMessage, 'userJoined', { local: true });

    const publishingOptions: PublishingOptions = yield call(
      RTCClient.publishingFeed.getJoinPublishingOptions
    );

    yield call(establishJanusConnectionSaga, data, publishingOptions);

    yield put(roomJoined());

    if (data?.externalStreams?.length) {
      for (const externalStreamAction of data.externalStreams) {
        yield put(externalStreamStarted(externalStreamAction));
      }
    }

    yield call(configureSDKStoredStateSaga, data.users);
  } catch (error) {
    yield call(Sentry.captureException, error);
    yield put(roomError({ global: true }));
  }
}
